import { AxiosResponse } from 'axios'
import { axiosHiringApi } from './axios'

export interface LocationSearchResult {
  ResultItems: Array<{
    PlaceId: string
    PlaceType: string
    Title: string
  }>
}

export class LocationApi {
  /**
   * Search for locations within the US
   * @param search The search query text
   * @returns Observable of location search results
   */
  static searchUSLocations(search: string): Promise<AxiosResponse<LocationSearchResult>> {
    return axiosHiringApi.post<LocationSearchResult>('/location/search', { search })
  }
}
